/* TODO:

  Decide where to put queries that are used by multiple components.

  We could create a common "queries" folder or we can keep the queries next to their
  primary use site.

*/
import gql from 'graphql-tag'
import { graphql, QueryProps } from 'react-apollo'

export const SPACE_TYPES_QUERY = gql`
  query SpaceTypes {
    spaceTypes(country: "FI") {
      id
      displayName
      description
      detail
    }
  }
`

export type SpaceType = {
  id: string
  displayName: string
  description?: string
  detail?: string
}

export type Response = {
  spaceTypes: SpaceType[]
}

export type SpaceTypeProps = Response & QueryProps

export function getWithSpaceTypes<T>() {
  return graphql<Response, T, SpaceTypeProps>(SPACE_TYPES_QUERY, {
    props: props => ({
      ...props.data
    })
  })
}



// WEBPACK FOOTER //
// ./src/Components/SpaceTypeSelect/spaceTypeQueries.ts